function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { default as local } from "./urls-local.js";
import { default as test } from "./urls-test.js";
import { default as stage } from "./urls-stage.js";
import { default as production } from "./urls-production.js";
import merge from "lodash/merge";
import { WebStorageStateStore } from "oidc-client";
export var initConfig = function initConfig(appName) {
  var _ref = window.environment ? window.environment : {
    name: "local"
  },
      envName = _ref.name,
      overrides = _objectWithoutProperties(_ref, ["name"]);

  var urls = {};
  var envConfigOverrides = {};

  switch (envName) {
    case "local":
      urls = local;
      urls.authDomain = process.env.REACT_APP_MOCK_SERVER ? "https://identity.uppdev.creditsafe.com" : "https://mylogin.test.creditsafe.com";
      envConfigOverrides.userStore = new WebStorageStateStore({
        store: window.localStorage
      });
      break;

    case "test":
      urls = test;
      break;

    case "stage":
      urls = stage;
      break;

    case "production":
      urls = production;
      break;

    default:
      break;
  }

  urls.appDomain = window.location.origin;
  var envConfig = generateEnvConfig(urls, appName, envConfigOverrides); // merge window.environment values with config values
  // window.environment settings takes precendence

  return merge(envConfig, overrides);
};

var generateEnvConfig = function generateEnvConfig(urls, appName, envConfigOverrides) {
  var config = {
    post_logout_redirect_uri: "".concat(urls.logoutRedirection),
    authority: "".concat(urls.authDomain),
    client_id: "upp",
    redirect_uri: "".concat(urls.appDomain, "/callback"),
    silent_redirect_uri: "".concat(urls.appDomain, "/silent-renew"),
    response_type: "token id_token",
    scope: "openid profile upp_api connect_web ubo_api_gateway",
    userStore: new WebStorageStateStore({
      store: window.sessionStorage
    }),
    metadata: {
      issuer: urls.authDomain,
      authorization_endpoint: "".concat(urls.authDomain, "/connect/authorize"),
      jwks_uri: "".concat(urls.authDomain, "/.well-known/openid-configuration/jwks?app=").concat(appName),
      end_session_endpoint: "".concat(urls.authDomain, "/connect/endsession?app=").concat(appName),
      check_session_iframe: "".concat(urls.authDomain, "/connect/checksession?app=").concat(appName),
      token_endpoint: "".concat(urls.authDomain, "/connect/token")
    }
  };
  return merge(config, envConfigOverrides);
};